import ResultView from './ResultView'
export default ResultView;